/**
 * The browser's own text-to-speech (the Web Speech API), for calling out what comes next while a
 * chart plays. Nothing is downloaded: the voices are the device's.
 */

import i18n from '../i18n';

export const canSpeak = typeof window !== 'undefined' && 'speechSynthesis' in window;

/** The app's language, so callouts say the instrument names the pills show — 'es' or 'en'. */
export const getSpeechLang = () => (i18n.language === 'es' ? 'es' : 'en');

// Looked up at speak time: Chrome fills the list in after the page loads
const findVoice = (lang) => {
  const voices = window.speechSynthesis.getVoices();

  return (
    voices.find((voice) => voice.lang.toLowerCase().startsWith(lang) && voice.localService) ||
    voices.find((voice) => voice.lang.toLowerCase().startsWith(lang)) ||
    null
  );
};

/**
 * iOS only speaks after speech has been started from a tap, so Play calls this before anything it
 * awaits. An empty utterance is enough and says nothing.
 */
export const primeSpeech = () => {
  if (!canSpeak) return;

  window.speechSynthesis.speak(new SpeechSynthesisUtterance(''));
};

export const cancelSpeech = () => {
  if (canSpeak) window.speechSynthesis.cancel();
};

/** Says `text` at `volume` (0..1), cutting off whatever is still being said rather than queueing behind it. */
export const speak = (text, lang = 'en', volume = 1) => {
  if (!canSpeak || !text) return;

  const utterance = new SpeechSynthesisUtterance(text);
  const voice = findVoice(lang);

  utterance.lang = voice?.lang || lang;
  if (voice) utterance.voice = voice;
  // A touch quicker than the default, so a callout a bar ahead is finished by the bar line
  utterance.rate = 1.1;
  utterance.volume = volume;

  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);
};
